import { LoadingKey } from '../app-active-loading/LoadingKey';
import { isCopyCarouselFinished, isLoadingKeyActive } from '../store/loading-status/selectors';
export const getCopyCarouselFinishedInACQ149Variant = state => {
  const isLoadingFinished = isLoadingKeyActive(state, LoadingKey.ACQ149PortalCreated) ? isCopyCarouselFinished(state, LoadingKey.ACQ149PortalCreated) : true;
  return isLoadingFinished;
};